import Vue from 'vue'
import DuiMessage from '../utils/message'
// import router from '../config/routes'
// import { Message } from 'element-ui'
// import Util from '../../util'

const vm = new Vue()

export function REMEMBER_SIGNIN ({
  dispatch,
  commit
}, info) {
  return vm.$http.get('/permission/authentication/qualify/basic/info').then((response) => {
    if (response.body.errId === 10000) {
      // window.location = 'http://172.16.10.5:7858/v1/auth/logincheck'
    }
    if (response.body.code === '0') {
      commit('SIGNIN', response.body.data)
      dispatch('getAccountInfo')
      if (response.body.data.company) {
        // 获得公司信息
        dispatch('getCompanyInfo')
      }
      dispatch('getUnreadMessageNum', response.body.data.userId)
    }
  }, (response) => {
    // window.location = 'http://172.16.10.5:7858/v1/auth/logincheck'
  })
}

export const getUnreadMessageNum = DuiMessage.getUnreadMessageNum // 获取未读消息数

// ============== account ============= //
// 获取账户信息
export function getAccountInfo ({
  dispatch,
  commit,
  state
}) {
  vm.$http.get(`/console/api/v1.0/business/coin/acctinfo`).then((response) => {
    if (response.body.errId === 0 && response.body.acctInfo && response.body.acctInfo.length > 0) {
      commit('SET_ACCOUNT', response.body.acctInfo[0])
    }
  })
}

// ===============product===============
// 获取公司信息
export function getCompanyInfo ({
  dispatch,
  commit,
  state
}) {
  vm.$http.get(`/permission/company/info`).then((response) => {
    if (response.body.code === '0') {
      commit('GET_COMPANYINFO', response.body.data)
    } else {
      Alert({
        type: 'error',
        message: response.body.error
      })
    }
  }, (response) => {})
}


// WEBPACK FOOTER //
// ./src/store/actions.js